
<template>
  <div>
    <template v-if="order.kind == 'pickup'">
      <v-alert type="info" :value="true">
        Pedido é para retira, nao precisa preencher nada nessa etapa
      </v-alert>
    </template>
    <template v-if="order.kind == 'delivery'">

      <v-row align="center" justify="space-between">
        
        <v-col cols='12' sm='12' class="pb-0" >
          <span class="title">Valor total do frete: {{ shipping_total_by_item.toLocaleString('pt-BR', {style: 'currency', currency: 'BRL'} ) }} </span>
          <v-divider></v-divider>
        </v-col>

        <v-col cols='12' sm='12' md='12' lg='12' class="mb-8">
          <span class="text-subtitle-1">Número de ajudantes</span>
          <v-row class="mx-0 mt-2">
            <v-btn x-small fab class="mx-1 elevation-0" color="primary" :outlined='order.shipping_attributes.number_assistants != 0' @click="order.shipping_attributes.number_assistants = 0"><v-icon large>mdi-numeric-0</v-icon></v-btn>
            <v-btn x-small fab class="mx-1 elevation-0" color="primary" :outlined='order.shipping_attributes.number_assistants != 1' @click="order.shipping_attributes.number_assistants = 1"><v-icon large>mdi-numeric-1</v-icon></v-btn>
            <v-btn x-small fab class="mx-1 elevation-0" color="primary" :outlined='order.shipping_attributes.number_assistants != 2' @click="order.shipping_attributes.number_assistants = 2"><v-icon large>mdi-numeric-2</v-icon></v-btn>
            <v-btn x-small fab class="mx-1 elevation-0" color="primary" :outlined='order.shipping_attributes.number_assistants != 3' @click="order.shipping_attributes.number_assistants = 3"><v-icon large>mdi-numeric-3</v-icon></v-btn>
          </v-row>
        </v-col>

        <v-col cols='12' sm='12' md='12' lg='12' class="py-0 mt-n3">
          <!-- <span class="text-subtitle-1">Data de entrega: </span> -->
          <v-divider class="pb-2"></v-divider>
          <!-- v-model="order.shipping_attributes.expected_delivery"  -->
          <v-text-field 
            label="Data da entrega" 
            readonly 
            :rules="required"
            :value="order.shipping_attributes.expected_delivery ? expectedDeliveryLabel : ''"
          ></v-text-field>
          Escolha a data de entrega
          <v-date-picker :rules="required" v-model="order.shipping_attributes.expected_delivery" full-width>
            <v-spacer></v-spacer>
          </v-date-picker>
        </v-col>
      </v-row>
    </template>
  </div>
</template>

<script>
import validations from '@/mixins/validations'
export default {
  name: 'ShippingData',
  mixins: [validations],
  props: {
    order: {
      type: Object,
    },
  },
  data() {
    return {
      dialog_date: false,
      currency:{
        currency: null,
        locale: 'en-EN',
        autoDecimalMode: true,
        decimalLength: 2,
        distractionFree:false,
      },
    }
  },
  computed: {
    expected_delivery_locale() {
      return this.expectedDeliveryLabel
    },
    expectedDeliveryLabel() {
      const date = this.order.shipping_attributes.expected_delivery
      if (!date) return null
      const raw = String(date).substring(0, 10)
      if (/^\d{4}-\d{2}-\d{2}$/.test(raw)) {
        return this.$moment(raw, 'YYYY-MM-DD').format('DD/MM/YYYY')
      }
      return this.$moment(date).format('DD/MM/YYYY')
    },
    shipping_total(){
      if (this.order.shipping_attributes.shipping_value_aux>0){
        let val = Number (this.order.shipping_attributes.shipping_value_aux.replace(/,/g, ''))
        val = this.order.items_attributes.reduce((acc, one)=> acc + Number(one.total_units_aux.replace(/,/g, '') ) , 0) * val
        return val.toLocaleString('pt-BR', {currency: 'BRL', style:'currency'})
      }
      return null
    },
    shipping_total_by_item(){
      if (this.order){
        let val = this.order.items_attributes.reduce((acc, one)=> acc + Number(one.total_ship.toString().replace(/,/g, '') ) , 0)
        return val.toLocaleString('pt-BR', {currency: 'BRL', style:'currency'})
      }
      return null
    },
  },
}
</script>